import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import ErrorPage from 'pricing-pages-ui/pages/ErrorPage';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getPrimaryTracker } from 'usage-tracker-container';
import { useIsHubSpotOnCreditsPilot } from './hooks/useIsHubSpotOnCreditsPilot';
import { useShouldHideDataOrSuitePage } from './hooks/useShouldHideDataOrSuitePage';
import AppLayout from './layouts/AppLayout';
import { useAppSelector } from './reducers';
import { HubSpotOnCreditsRoutes } from './routes/HubSpotOnCreditsRoutes';
import { AddOnsPageV2, BundlePage, CommerceHubPageV2, ContentHubPageV2, CustomerPlatformPageV2, DataHubPageV2, FreeToolsPageV2, HubSpotCreditsPageV1, HubSpotCreditsPageV2, InterstitialPage, MarketingHubPageV2, MarketingPlusPageV2, SalesHubPageV2, ServiceHubPageV2, SmartCrmPageV2 } from './routes/loadablePages';
import { DefaultInAppRoute } from './routes/routeHelpers';
import { isAppAuthSelector } from './selectors/AuthSelectors';
import { isUngatedForHubSpotCreditsPageV2Selector, isUngatedForSeatsSelector } from './selectors/GatingSelectors';
import { ResponsivePageWrapper } from './v2/ResponsivePageWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Routes() {
  const {
    isInPilot: isHSoCPilot
  } = useIsHubSpotOnCreditsPilot();
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const shouldHideDataOrSuitePage = useShouldHideDataOrSuitePage();
  const isUngatedForHubSpotCreditsPageV2 = useAppSelector(isUngatedForHubSpotCreditsPageV2Selector);
  getPrimaryTracker().setProperties({
    isSeatsPilot: isUngatedForSeats
  });
  if (isHSoCPilot) {
    return /*#__PURE__*/_jsx(HubSpotOnCreditsRoutes, {});
  }
  return /*#__PURE__*/_jsx(AppLayout, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [isAppAuth && /*#__PURE__*/_jsx(Route, {
        path: "/:page/*",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => /*#__PURE__*/_jsx(Redirect, {
          to: Object.assign({}, location, {
            pathname: `/${page}`
          })
        })
      }), shouldHideDataOrSuitePage && /*#__PURE__*/_jsx(Route, {
        path: ['/data', '/operations', '/suite'],
        children: /*#__PURE__*/_jsx(Redirect, {
          to: "/marketing"
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/interstitial",
        component: InterstitialPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "bundle",
          children: /*#__PURE__*/_jsx(BundlePage, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing-plus",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "marketing-plus",
          children: /*#__PURE__*/_jsx(MarketingPlusPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/crm",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "crm",
          children: /*#__PURE__*/_jsx(FreeToolsPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/add-ons",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "add-ons",
          children: /*#__PURE__*/_jsx(AddOnsPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/hubspot-credits",
        render: () => {
          const PageComponent = isUngatedForHubSpotCreditsPageV2 ? HubSpotCreditsPageV2 : HubSpotCreditsPageV1;
          return /*#__PURE__*/_jsx(ResponsivePageWrapper, {
            navItem: "hubspot-credits",
            children: /*#__PURE__*/_jsx(PageComponent, {})
          });
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/suite",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "suite",
          children: /*#__PURE__*/_jsx(CustomerPlatformPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "MARKETING",
          children: /*#__PURE__*/_jsx(MarketingHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/sales",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "SALES",
          children: /*#__PURE__*/_jsx(SalesHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/service",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "SERVICE",
          children: /*#__PURE__*/_jsx(ServiceHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/content",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "CMS",
          children: /*#__PURE__*/_jsx(ContentHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/data",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "OPERATIONS",
          children: /*#__PURE__*/_jsx(DataHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/commerce",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          productLine: "COMMERCE",
          children: /*#__PURE__*/_jsx(CommerceHubPageV2, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/smart-crm",
        render: () => /*#__PURE__*/_jsx(ResponsivePageWrapper, {
          navItem: "smart-crm",
          children: /*#__PURE__*/_jsx(SmartCrmPageV2, {})
        })
      }), isAppAuth ? /*#__PURE__*/_jsx(DefaultInAppRoute, {}) : /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: createToObject('/suite')
      }), /*#__PURE__*/_jsx(Route, {
        component: ErrorPage
      })]
    })
  });
}